<template>
  <div class="flex flex-col justify-center items-center h-screen gap-4 p-2">
    <img src="../../assets/images/404.svg" alt="404-img" class="w-100 h-64" />
    <p class="text-xl font-bold">Erro 404</p>
    <p class="text-gray-700 text-center w-100 md:w-2/6">
      Ops! Parece que a página que você está procurando não existe, sentimos
      muito por isso.
    </p>

    <!-- <div class="mt-5">
      <Button label="Ir para o início" class="btn-outline p-button-sm" />
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "notFound",
});
</script>

<style></style>
